import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { fetchAPI } from "@/utility/NetworkUtils";
import PublicCatalogLayout from "@/layouts/PublicCatalogLayout"
import WarehouseCategoriesTable from "@/warehouse/categories/WarehouseCategoriesTable";
const InventoryCategoriesManagementDashboard = (props) => {
  const { renter, user } = props;

  const [ categories, setCategories ] = useState([]);
  const [ loading, setLoading ] = useState(false);

  return (
    <PublicCatalogLayout
      classNames={{container: 'inventory-dashboard'}}
      className="inventory-management-dashboard"
      currentPage=""
      {...props}
      breadcrumbs={[
        {name: `${renter.name} Inventory`, url: `/inventory/${renter.id}`},
        {name: "Manage Inventory", url: `/inventory/${renter.id}/items`},
        {name: "Categories"},
      ]}
    >
      <div className="row">
        <div className="col-xs-12">
          <h1 class="catalog-h1">Categories</h1>
        </div>
      </div>
      {loading ? (
        <div>Loading...</div>
      ) : (
        <WarehouseCategoriesTable renter={renter} user={user} />
      )}
    </PublicCatalogLayout>
  );
};

export default InventoryCategoriesManagementDashboard